export default __webpack_public_path__ + "assets/icons/user.svg";